type RawLink = {
    id?: number | string | null;
    link?: string | null;
    links?: string | null;
    document_library_item_id?: number | string | null;
};

type RawUpload = {
    id?: number | string | null;
    fileName?: string | null;
    file_name?: string | null;
    displayName?: string | null;
    display_name?: string | null;
    document_library_item_id?: number | string | null;
};

type RawDocument = {
    id?: number | string | null;
    title?: string | null;
    display_name?: string | null;
    external_url?: string | null;
    storage_path?: string | null;
};

export type NormalizedDatumLink = {
    href: string;
    label: string;
    document_library_item_id: number | null;
};

export type NormalizedDatumUpload = {
    fileName: string;
    displayName: string;
    document_library_item_id: number | null;
};

const normalizeString = (value: unknown) => typeof value === 'string' ? value.trim() : '';

const normalizeDocumentLibraryItemId = (value: unknown) => {
    const parsed = parseInt(String(value), 10);
    return Number.isInteger(parsed) && parsed > 0 ? parsed : null;
};

export const normalizeDatumLinks = (rawLinks: RawLink[] = [], rawDocuments: RawDocument[] = []): NormalizedDatumLink[] => {
    const links: NormalizedDatumLink[] = [];
    const seenLinks = new Set<string>();

    (Array.isArray(rawLinks) ? rawLinks : []).forEach((link) => {
        const href = normalizeString(link?.links ?? link?.link);
        if (href === '' || seenLinks.has(href)) {
            return;
        }

        seenLinks.add(href);
        links.push({
            href,
            label: href,
            document_library_item_id: normalizeDocumentLibraryItemId(link?.document_library_item_id),
        });
    });

    (Array.isArray(rawDocuments) ? rawDocuments : []).forEach((document) => {
        const href = normalizeString(document?.external_url);
        if (href === '' || seenLinks.has(href)) {
            return;
        }

        seenLinks.add(href);
        links.push({
            href,
            label: normalizeString(document?.display_name) || normalizeString(document?.title) || href,
            document_library_item_id: normalizeDocumentLibraryItemId(document?.id),
        });
    });

    return links;
};

export const normalizeDatumUploads = (rawUploads: RawUpload[] = [], rawDocuments: RawDocument[] = []): NormalizedDatumUpload[] => {
    const uploads: NormalizedDatumUpload[] = [];
    const seenUploads = new Set<string>();

    (Array.isArray(rawUploads) ? rawUploads : []).forEach((upload) => {
        const fileName = normalizeString(upload?.fileName ?? upload?.file_name);
        if (fileName === '' || seenUploads.has(fileName)) {
            return;
        }

        seenUploads.add(fileName);
        uploads.push({
            fileName,
            displayName: normalizeString(upload?.displayName ?? upload?.display_name) || fileName,
            document_library_item_id: normalizeDocumentLibraryItemId(upload?.document_library_item_id),
        });
    });

    (Array.isArray(rawDocuments) ? rawDocuments : []).forEach((document) => {
        const fileName = normalizeString(document?.storage_path);
        if (fileName === '' || seenUploads.has(fileName)) {
            return;
        }

        seenUploads.add(fileName);
        uploads.push({
            fileName,
            displayName: normalizeString(document?.display_name) || normalizeString(document?.title) || fileName,
            document_library_item_id: normalizeDocumentLibraryItemId(document?.id),
        });
    });

    return uploads;
};
